var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$company.setting
    ? _c("div", { staticClass: "tile is-parent pl-1" }, [
        _c("section", { staticClass: "tile is-child box" }, [
          _c("div", { staticClass: "subtitle" }, [_vm._v("Company Setting")]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Item Description AutoComplete"),
            ]),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "pretty p-switch p-fill" }, [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: _vm.$company.setting.itemAutoCompleteEnabled,
                  },
                  on: { change: _vm.onChangeAutoCompleteSwitch },
                }),
                _c("div", { staticClass: "state p-primary" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$company.setting.itemAutoCompleteEnabled
                          ? "On"
                          : "Off"
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Parts Control Enabled"),
            ]),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "pretty p-switch p-fill" }, [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: _vm.$company.setting.partsControlEnabled,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.onChangePartsControlSwitch(
                        $event,
                        "PartsControlEnabled"
                      )
                    },
                  },
                }),
                _c("div", { staticClass: "state p-primary" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$company.setting.partsControlEnabled ? "On" : "Off"
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Quote AutoSave Enabled"),
            ]),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "pretty p-switch p-fill" }, [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: _vm.$company.setting.quoteAutoSaveEnabled,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.onChangePartsControlSwitch(
                        $event,
                        "QuoteAutoSaveEnabled"
                      )
                    },
                  },
                }),
                _c("div", { staticClass: "state p-primary" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$company.setting.quoteAutoSaveEnabled ? "On" : "Off"
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }